<!-- <p>loading-spinner-dialog works!</p> -->
<div>
  <h1 mat-dialog-title>Please Wait</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <!-- <i>Please wait while adding new user!</i> -->
      <mat-spinner></mat-spinner>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
</div>
